import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is the ₹100 a one-time payment or recurring?",
    a: "It is a one-time annual fee. You will not be charged again unless you choose to renew after 12 months.",
  },
  {
    q: "How do I receive the membership card?",
    a: "After successful payment, a single-side card image is delivered instantly to your WhatsApp number along with an SMS receipt. You can also download it directly from the success screen.",
  },
  {
    q: "Can my family use the same card?",
    a: "The card is in your name, but your spouse, parents and children can avail the same 10% discount on diagnostics by mentioning your membership number at billing.",
  },
  {
    q: "Where is the card accepted?",
    a: "At every 1Rupee Clinic, diagnostic centre and partner pharmacy across the country. Just show your card or share the membership number.",
  },
  {
    q: "How is the membership number generated?",
    a: "Each card receives a unique alphanumeric ID so it cannot be guessed or duplicated.",
  },
  {
    q: "Is my payment information secure?",
    a: "Yes. All transactions are processed by Razorpay, which is PCI-DSS Level 1 compliant. We never store your card details on our servers.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="py-20 sm:py-28 bg-gradient-soft">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">
            FAQs
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
            Everything you might <span className="text-gradient-aqua">wonder.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-border/70 bg-card px-5 sm:px-6 data-[state=open]:shadow-soft data-[state=open]:border-primary/25 transition"
            >
              <AccordionTrigger className="text-left font-display font-semibold text-base sm:text-lg hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
